import { State } from '../types';
import { stitchChangeKeyObjects } from './utils';
import { getSandboxEntitlementsLinkedToProducts } from './get-sandbox-oms-payload';
import { ROVO_PRODUCT_ID } from '@css-xp/ppc-constants';

export const getSandboxLinkedEntitlementInCart = (state: State) => {
  const selectedProducts = Object.values(stitchChangeKeyObjects(state.products, state.selectedProducts));
  const { linkedEntitlements, products } = getSandboxEntitlementsLinkedToProducts(selectedProducts, {
    sandboxAppsObj: state.sandboxApps,
    sandboxProductsObj: state.sandboxProducts,
  });

  // Check if Rovo Entitlements are in cart
  const rovoEntilementsInCart = products.filter((product) => product.productId === ROVO_PRODUCT_ID);
  const isRovoEntilementsInCart = rovoEntilementsInCart.length > 0;

  // Check if Sandbox Linked Entitlements are in cart
  const isSandboxLinkedEntitlementsInCart =
    linkedEntitlements.length || (products.length && products.length !== rovoEntilementsInCart.length);

  return { isSandboxLinkedEntitlementsInCart, isRovoEntilementsInCart };
};
